import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Animation {
    run() {
        this.triggerPack();
        
        if(window.innerWidth > 414){ this.set();}
        if(window.innerWidth > 414){ this.animation() }
    }
    triggerPack(){
        $( ".btn-trigger-cloud" ).on('click', function() {
            $('#sub-category-cloud').removeClass('hide-secret');
            $('#configuration').addClass('less-padding');
            $('#sub-category-custom').addClass('hide-secret');
            $('#configuration .kanban-cloud').addClass('selected-pack-red');
            $('#configuration .kanban-custom').removeClass('selected-pack-blue')
        });
        $( ".btn-trigger-custom" ).on('click', function() {
            $('#sub-category-custom').removeClass('hide-secret');
            $('#configuration').addClass('less-padding');
            $('#sub-category-cloud').addClass('hide-secret');
            $('#configuration .kanban-custom').addClass('selected-pack-blue');
            $('#configuration .kanban-cloud').removeClass('selected-pack-red');
        });
               
    }
    set(){
        gsap.set('[class*="section-"] .row:nth-child(even) .icon-container',{
            autoAlpha: 0,
            x: -100,
        })

        gsap.set('[class*="section-"] .row:nth-child(odd) .icon-container',{
            autoAlpha: 0,
            x: 100,
        })

        gsap.set('[class*="section-"] .row:nth-child(even) .text-container',{
            autoAlpha: 0,
            x: 100,
        })

        gsap.set('[class*="section-"] .row:nth-child(odd) .text-container',{
            autoAlpha: 0,
            x: -100,
        })
        gsap.set('.three-point-grey',{
            autoAlpha: 0,
            y: -100,
        })
        gsap.set('#three-images .text-level ',{
            autoAlpha: 0,
            y: -100,
        })
        gsap.set('#three-packs .point ',{
            autoAlpha: 0,
            y: -100,
        })
        gsap.set('.image-background .animation-text ',{
            autoAlpha: 0,
            x: -100,
        })
        gsap.set('#motivation .motivation-text.order-lg-1',{
            autoAlpha: 0,
            x: -100,
        })

        gsap.set('#motivation .motivation-text.order-lg-2',{
            autoAlpha: 0,
            x: 100,
        })

        gsap.set('#motivation .motivation-img.order-lg-2',{
            autoAlpha: 0,
            x: 100,
        })

        gsap.set('#motivation .motivation-img.order-lg-1',{
            autoAlpha: 0,
            x: -100,
        })
    }
    animation(){
        /*const panels = gsap.utils.toArray(".panel-approccio");
        panels.forEach((panel, i) => {
          ScrollTrigger.create({
            trigger: panel,
            start: "top top",
            scrub: true,
            pin: true,
            pinSpacing: false,
          });
        });*/

        /* const sections = gsap.utils.toArray(".panel-approccio");

        sections.forEach((section, index) => {
          const text = section.querySelector("p"),
          color = section.querySelector(".container");
    
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              pin: true,
              anticipatePin: 1,
              scrub: 1,
              start: "top top",
              end: "+=500",
              //markers: true
            }
          });
          if (index > 0) {
            tl.from(text, { opacity: 0,  ease: "ease", duration: 10  })
            .from(color, { opacity: 0, ease: "ease", duration: 10 });
          }
          if (index < sections.length - 1) {
            tl.to(text, { opacity: 0, ease: "ease", duration: 15  })
            .to(color, { opacity: 0, ease: "ease", duration: 15 });
          }
        }); */







        $('#motivation .container-point').each(function(){
            var image = $(this).find('.motivation-text, .motivation-img');
            gsap.to(image,{
                duration: 2,
                autoAlpha: 1,
                x:0,
                scrollTrigger: {
                    trigger: $(this),
                    start: 'bottom bottom', // bottom 100%-=20
                    end: 'bottom bottom',
                    once: true,
                    // toggleActions: 'play none play reverse',
                    
                }
            })
        });
        $('[class*="section-"] .row').each(function(){
            var image = $(this).find('.icon-container, .text-container');

            gsap.to(image,{
                duration: 2,
                autoAlpha: 1,
                x:0,
                scrollTrigger: {
                    trigger: $(this),
                    start: 'bottom bottom',
                    end: 'bottom bottom',
                    once: true,
                    // toggleActions: 'play none play reverse',
                    
                }
            })
        });
        gsap.to('.image-background .animation-text',{
            duration: 3,
            autoAlpha: 1,
            x:0,
        })
        gsap.to('.three-point-grey',{
            duration: 2,
            autoAlpha: 1,
            y:0,
            scrollTrigger: {
                trigger: '.three-point-grey',
                start: 'bottom bottom',
                end: 'bottom bottom',
                once: true,
                // toggleActions: 'play none play reverse',
                
            }
        })  
        gsap.to('#approccio',{
            duration: 2,
            autoAlpha: 1,
            y:0,
            scrollTrigger: {
                trigger: '#approccio',
                start: 'bottom bottom',
                end: 'bottom bottom',
                once: true,
                // toggleActions: 'play none play reverse',
                
            }
        })        
        gsap.to('#three-packs .point ',{
            duration: 2,
            autoAlpha:1,
            y: 0,
            scrollTrigger: {
                trigger: '#three-packs',
                start: 'top 100%',
                end: 'bottom bottom',
                once: true,
                // toggleActions: 'play none play reverse',
                
            }
        })     
        gsap.to('.page-partnership #three-images .text-level',{
            duration: 2,
            autoAlpha: 1,
            y:0,
            scrollTrigger: {
                trigger: '.page-partnership #three-images .text-level',
                start: 'bottom bottom',
                end: 'bottom bottom',
                once: true,
                // toggleActions: 'play none play reverse',
                
            }
        })
        $(document).scroll(function() {
            var y = $(this).scrollTop();
            if (y > 600) {
            $('.scroll-drop-up').removeClass('d-none');
            } else {
              $('.scroll-drop-up').addClass('d-none');
            }
          });
    }
}

const animation = new Animation();
export default animation;
